import * as React from 'react';
import DeleteIcon from '@mui/icons-material/Remove';
import { Card, TextField, IconButton } from '@mui/material';

import { createFieldArray } from 'utils/form';

type Props = {
  title?: string;
  value: string[];
  placeholder?: string;
  error?: string | null;
  onChange: (next: string[]) => void;
};

export const InputArrayField: React.FC<Props> = ({
  value,
  error,
  onChange,
  placeholder,
  title = 'Item',
}) => {
  const StringArrayField = React.useMemo(
    () =>
      createFieldArray<string>(
        () => '',
        (item, index, onItemChange, onRemove) => (
          <Card variant="outlined" className="flex w-full gap-4 p-4">
            <div className="flex flex-1 items-center gap-2">
              <TextField
                fullWidth
                value={item}
                label={`${title} #${index + 1}`}
                placeholder={placeholder ?? `${title}`}
                onChange={(e) => onItemChange(e.target.value)}
              />
              <IconButton
                size="small"
                onClick={onRemove}
                aria-label={`Remove ${title.toLowerCase()} #${index + 1}`}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </div>
          </Card>
        )
      ),
    [placeholder, title]
  );

  return (
    <StringArrayField
      title={title}
      value={value}
      error={error ?? null}
      onChange={(next: unknown) => onChange(next as string[])}
    />
  );
};
